export enum TrapType {
  MCT = 'mct',
  SRST = 'srst',
  SMST = 'smst',
  SRBM = 'srbm',
  ALL = 'mct_smst',
}
